export default __webpack_public_path__ + "static/media/Syllabus.a84af333.pdf";